import { useLanguage } from "@/contexts/LanguageContext";
import { useSiteContent } from "@/contexts/SiteContentContext";
import { CONTACT as DEFAULT_CONTACT } from "@/data/contact";

/**
 * Returns brand + contact info merged with overrides from SiteContent.
 * Components should use this hook INSTEAD of importing CONTACT directly.
 */
export function useBrandAndContact() {
  const { lang } = useLanguage();
  const { merged } = useSiteContent();

  const brand = merged?.brand || {};
  const contact = merged?.contact || {};

  const phone = contact.phone || DEFAULT_CONTACT.phone;
  const cleanPhone = phone.replace(/\s/g, "");
  const phoneHref = contact.phoneHref || `tel:${cleanPhone}`;
  const whatsappHref =
    contact.whatsappHref ||
    `https://wa.me/${cleanPhone.replace(/[^0-9]/g, "")}`;
  const email = contact.email || DEFAULT_CONTACT.email;
  const emailHref = contact.emailHref || `mailto:${email}`;
  const instagramHref = contact.instagramHref || DEFAULT_CONTACT.instagramHref;

  const cityKey = lang === "fr" ? "city_fr" : "city_en";
  const city =
    contact[cityKey] ||
    contact.city_fr ||
    DEFAULT_CONTACT[cityKey] ||
    DEFAULT_CONTACT.city_fr;

  const brandName = brand.name || DEFAULT_CONTACT.brand;
  const baselineKey = lang === "fr" ? "baseline_fr" : "baseline_en";
  const baseline = brand[baselineKey] || brand.baseline_fr || "";

  return {
    brand: brandName,
    baseline,
    phone,
    phoneHref,
    whatsappHref,
    email,
    emailHref,
    instagramHref,
    city,
  };
}
